import React from 'react';
import { useSelector } from 'react-redux';
import { useIsMobileDevice } from 'utils';
import { useDialogBehavior } from '../../hooks';
import {
  ordersSelector,
  ordersEnabledSelector,
} from '../../redux/selectors/ordersSelector';
import { AskProductModalView } from '../AskProductModalView';

// TODO: could we cleanup the entire module? It does not seem to be used anymore.
export const AskProductModal = () => {
  const { treatmentAttrs, lastOrderCutoff, isForcedOpen, setIsForcedOpen } =
    useDialogBehavior();
  const isMobile = useIsMobileDevice('lg');
  const { orders } = useSelector(ordersSelector);
  const isAPQEnabled = useSelector(ordersEnabledSelector);

  const shouldRender = () =>
    treatmentAttrs && treatmentAttrs.groupID && isAPQEnabled === 1;

  if (!shouldRender()) {
    return null;
  }

  if (orders.length === 0 && !isForcedOpen) {
    return null;
  }

  return !isMobile ? (
    <AskProductModalView
      orders={orders}
      lastOrderCutoff={lastOrderCutoff}
      isForcedOpen={isForcedOpen}
      setIsForcedOpen={setIsForcedOpen}
    />
  ) : null;
};
